// src/components/Dashboard.js
import React, { useState, useRef, useParams } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DataTable, { Alignment } from 'react-data-table-component';
import { useReactToPrint } from "react-to-print";
import Table from "react-bootstrap/Table";
import './App.css';
import Loader from "./LoadingScreen";
const TableSettings = {
    "font-size": "10px"
  };
  const  inputText = {
    "float": "right",
    "marginLeft": "10px",
    "width": "55%"
  };
  const tableStandardCSS = {
    "width": "98%",
     "border": "1px solid #000",
       "borderCollapse": "collapse",
       "margin": "0 0 1% 0"
  }

  const tableStandardCSS1 = {
    "width": "98%",
     "border": "0",
       "borderCollapse": "collapse",
       "margin": "5px"
  }

  const pStandardCSS = {
    margin: "0"
  }

  const tdStyle = {
    "border": "1px solid #000", width: "5%", textAlign: "center"
  }
  
const ReservationDetails = (props) => {
  function formatIndian(num) {
  return num.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
}
  const navigte = useNavigate();
  const componentRef = useRef();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [commonDetails, setCommonDetails] = useState([]);
  const [data, setData] = useState([]);
  const [item, setItem] = useState([]);
  const [total, setTotal] = useState();
  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  let [estimatedCost, setEstimatedCost] = useState(null);
  const [creationUserName, setCreationUserName] = useState();
  const [headerNote, setHeaderNote] = useState();
  const config = {
    headers: { Authorization: `Bearer ${token}` }
};
  const handlePrint = useReactToPrint({
    documentTitle: 'Title',
    contentRef: componentRef,
  });
  const formatDate = (data) => {
  if (data) {
    let msDate = data;
    let timestamp = parseInt(msDate.match(/\d+/)[0], 10);
    let date = new Date(timestamp);

    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear(); // full year

    return `${day}-${month}-${year}`;
  } else {
    return "";
  }
};
function parseSapDate(sapDate) {
    // Match /Date(1234567890)/ or /Date(1234567890+0000)/
    const match = /\/Date\((\d+)(?:[+-]\d+)?\)\//.exec(sapDate);
    if (match) {
        const timestamp = parseInt(match[1], 10); // milliseconds
        const date = new Date(timestamp);
        // Format as dd-mm-yyyy
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    } else {
        // Fallback: try normal date parsing
        const date = new Date(sapDate);
        if (!isNaN(date)) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }
    return sapDate; // return original if parsing fails
};
  useEffect(() => {
    var totalValue;
      setCommonDetails([]); // Clear existing state on reload
      //console.log(baseUrl+`auth/getPRDetails?PurchaseRequisition=${id}&user_id=${userId}`);
    axios.get(baseUrl+`auth/getReservationDetails?user_id=${userId}&Reservation=${id}`, config)
      .then(response => {
        const header = response.data?.data?.value?.[0] ?? null;
const items  = response.data?.data?.value?.[0]?._items ?? [];
setData(header);   // reservation header data
setItem(items);    // line items
setLoading(false);
        //console.log(response.data.data.value); return false;
        /* const totalValue = data.to_ServiceEntrySheetItem.reduce(
  (acc, item) => acc + parseFloat(item.NetAmount || 0),
  0
);
const formattedValue = totalValue.toLocaleString('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
setTotal(formattedValue);
        setData(data);
        setLoading(false); */
      })
      .catch(error => {
        console.log(error.reponse);
        setLoading(false);
      });
  }, []);
  
  return (
<>
<Topbar></Topbar>
{loading ? <Loader /> :
<div className="page-wrapper">
            <div className="container-fluid">
                <div className="row page-titles">
                    <div className="col-md-5 align-self-center">
                        <h4 className="text-themecolor">Reservation Details</h4>
                    </div>
                    <div className="col-md-7 align-self-center text-end">
                        <div className="d-flex justify-content-end align-items-center">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                                <li className="breadcrumb-item active">Reservation Details</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                 <div ref={componentRef} className="parentComponent">
    <table style={tableStandardCSS1}>
        <tbody>
            <tr>
                <td width={"30%"}>
                    <img src="data:image/jpeg;base64,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"
                                              width='30%' height='auto'></img>
                </td>
                <td width={"33%"} style={{textAlign: "center"}}>  <h3>KALINGA COMMERCIAL CORPORATION LIMITED</h3>
</td>
                <td style={{width: "36%", textAlign: "right"}}>
                    <p style={{fontWeight: "bold", margin: 0}}>Registered & Head Office</p>
<p style={pStandardCSS}>Plot No. : A/47, Nilakantha Nagar, Nayapalli,</p>
  <p style={pStandardCSS}> Bhubaneswar - 751012, Odisha</p>
<p style={pStandardCSS}>Telephone: +91 6743580269</p>
<p style={pStandardCSS}>Email ID: material@kccl.co.in</p>
<p style={pStandardCSS}>GST NO: 21AADCK6272E1ZV</p>
{/* <p style={{ margin: "12px 0 0 0" }}><span style={{fontWeight: "bold"}}>Document No. :</span> {data.header.MaterialDocument} / {data.header.MaterialDocumentYear}
</p> */}
{/* <p><span style={{fontWeight: "bold"}}>SES No : </span><span >{data.header.ServiceEntrySheet}</span></p>
 */}                </td>
            </tr>
        </tbody>
    </table>
        <table style={tableStandardCSS1}>
          <tbody>
            <tr>
              <td></td>
            <td colSpan={3} width={"30%"}><h6>Material Reservation Slip</h6></td>
              <td></td>
            </tr>
          </tbody>
          
        </table>
    <table style={tableStandardCSS} className="leanTable">
        <tbody>
            <tr>
                <td>
                   <span style={{fontWeight: "bold"}}>Reservation No:</span> {data?.Reservation}
                </td>
                <td>
                   <span style={{fontWeight: "bold"}}>Movemnet Type:</span> {data?.GoodsMovementType}
                </td>
                </tr>
                <tr>
                <td colSpan={2}>
                    <span style={{fontWeight: "bold"}}>Cost Centre :</span>	{data?.CostCenterDescription}
                </td>
                </tr>
                <tr>
                <td colSpan={2}><span style={{fontWeight: "bold"}}>Date of reservation :</span> {parseSapDate(data?.ReservationDate)}</td>
            </tr>
            {/* <tr>
                <td colSpan={2} style={{borderTop: "1px solid #000", height: "75px", verticalAlign: "top"}}>
                    <span style={{fontWeight: "bold"}}>Header Note: </span> {data?.header?._ServiceEntrySheetNote?.[0]?.NoteBasicType === "SES_HEADER_NOTE"
  ? data?.header?._ServiceEntrySheetNote?.[0]?.NoteBasicContent
  : ""}
                </td>
            </tr> */}
        </tbody>
    </table>
    <table style={tableStandardCSS}>
        <tbody>
        <tr style={{fontWeight: "bold"}}>
            <td style={{border: "1px solid #000", width: "5%", textAlign: "center"}}>Sl.No</td>
            <td style={{border: "1px solid #000", width: "11%", textAlign: "center"}}>Material</td>
            <td style={{border: "1px solid #000", width: "19%", textAlign: "center"}}>Description</td>
            <td style={{border: "1px solid #000", width: "3%", textAlign: "center"}}>Unit</td>
            <td style={{border: "1px solid #000", width: "3%", textAlign: "center"}}>Plant Stock</td>
            <td style={{border: "1px solid #000", width: "9%", textAlign: "center"}}>Quantity Required</td>
{/*             <td style={{border: "1px solid #000", width: "12%", textAlign: "center"}}>Quantity Issued</td>
 */}{/*             <td style={{border: "1px solid #000", width: "5%", textAlign: "center"}}>Balance Qty</td>
 */}            <td style={{border: "1px solid #000", width: "12%", textAlign: "center"}}>Plant</td>
            <td style={{border: "1px solid #000", width: "12%", textAlign: "center"}}>Store</td>
            <td style={{border: "1px solid #000", width: "12%", textAlign: "center"}}>Remarks</td>
        </tr>
        {item.map((item, index) => (
  <tr key={item.ReservationItem} style={{ borderTop: "1px solid #000" }}>
    <td style={tdStyle}>{index + 1}</td>
    <td style={tdStyle}>{item.Product}</td>
    <td style={tdStyle}>{item.ProductName || "-"}</td>
    <td style={tdStyle}>{item.BaseUnit}</td>
    <td style={tdStyle}>{item.MatPlantStock}</td>
    <td style={tdStyle}>{item.ResvnItmRequiredQtyInEntryUnit}</td>
{/*     <td style={tdStyle}>{item.ResvnItmWithdrawnQtyInBaseUnit}</td>
 */}{/*     <td style={tdStyle}>{item.BalanceQty}</td>
 */}    <td style={tdStyle}>{item.Plant}</td>
    <td style={tdStyle}>{item.StorageLocation}</td>
    <td style={tdStyle}>{item.ReservationItemText}</td>
  </tr>
))}


        {/* <tr>
            <td style={{border: "1px solid #000"}}></td>
            <td style={{border: "1px solid #000", textAlign: "center"}} colSpan={5}><span style={{fontWeight: "bold"}}>Total excluding GST</span></td>
            <td style={{border: "1px solid #000", textAlign: "center"}}><span style={{fontWeight: "bold"}}>{total}</span></td>
            <td style={{border: "1px solid #000"}}></td>
        </tr> */}
        </tbody>
    </table>
    {/* <table style={tableStandardCSS}>
        <tbody>
            <tr style={{fontWeight: "bold"}}>
            <td style={{paddingTop:"15px"}}>Prepared By</td>
            <td style={{paddingTop:"15px"}}>Verified By</td>
            <td style={{paddingTop:"15px"}}>Approved By</td>
        </tr>
        <tr>
            <td colSpan={3}><span style={{fontWeight: "bold"}}>User Id:</span> {data.header.YY1_SEUserName_MDH}</td>
        </tr>
        <tr>
            <td colSpan={3}><span style={{fontWeight: "bold"}}>Date of Creation:</span> {data.header.CreationDateTime}</td>
        </tr>
        </tbody>
    </table> */}
                  </div>
                    <button onClick={() => handlePrint()} style={{marginTop:"10px", marginLeft: "45%"}}>Print this out!</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
</>
  );
};

export default ReservationDetails;
